//
//
//
//
//
//
//
//
//
//
//
//
//

import ChatFeed from './components/chat-feed'
import NavComponent from './components/nav'

export default {
  name: 'app',
  components: {
    NavComponent,
    ChatFeed
  },
  mounted: function () {
    document.cookie = 'very-important-cookie=important-info'
  }
}



// WEBPACK FOOTER //
// ./src/App.vue